// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__cDwQ+","spin":"spinner_spin__f6-y6"};